var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "page-header-wrapper padding-rb" },
        [
          _c(
            "PageHeader",
            { attrs: { title: "vCE List" } },
            [
              _c("el-input", {
                directives: [
                  {
                    name: "debounce",
                    rawName: "v-debounce",
                    value: _vm.onSearch,
                    expression: "onSearch",
                  },
                ],
                staticClass: "select",
                staticStyle: { "margin-right": "0px" },
                attrs: {
                  "prefix-icon": "el-icon-search",
                  placeholder: "Search",
                  clearable: "",
                },
                on: { clear: _vm.onSearch },
                model: {
                  value: _vm.searchVal,
                  callback: function ($$v) {
                    _vm.searchVal = $$v
                  },
                  expression: "searchVal",
                },
              }),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", icon: "el-icon-download" },
                  on: { click: _vm.openExportReportDialog },
                },
                [_vm._v(" Download Report ")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "role",
                      rawName: "v-role",
                      value: [2, 3, 13],
                      expression: "[2, 3, 13]",
                    },
                  ],
                  attrs: { type: "primary", icon: "el-icon-refresh" },
                  on: { click: _vm.refreshWeCom },
                },
                [_vm._v(" Refresh WeCom ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table-wrapper" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.tableLoading,
                  expression: "tableLoading",
                },
              ],
              ref: "table",
              attrs: {
                data: _vm.tableData,
                "element-loading-text": "Loading...",
              },
              on: {
                "sort-change": _vm.onSortChange,
                select: _vm.handleSelect,
                "select-all": _vm.handleSelectionAll,
              },
            },
            [
              [
                _c("el-table-column", {
                  attrs: {
                    type: "selection",
                    width: "45",
                    align: "center",
                    selectable: _vm.disableSelection,
                  },
                }),
              ],
              _c("el-table-column", {
                attrs: {
                  prop: "SEName",
                  label: "Name",
                  "min-width": "110",
                  sortable: "custom",
                  fixed: "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "City",
                  label: "City",
                  "min-width": "80",
                  sortable: "custom",
                  fixed: "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "hospital",
                  label: "Hospital / Institution",
                  "min-width": "180",
                  sortable: "custom",
                  fixed: "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "Department",
                  label: "Department",
                  "min-width": "140",
                  sortable: "custom",
                  fixed: "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "Phone",
                  label: "Phone",
                  "min-width": "100",
                  sortable: "custom",
                  fixed: "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "Types",
                  label: "Type",
                  "min-width": "100",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "Tags", label: "Tag", "min-width": "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("hcp-tag-cell", { attrs: { value: row.Tags } }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "TargetMLName",
                  label: "vMSL",
                  "min-width": "100",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "Match",
                  width: "160",
                  label: "iDoctor Match",
                  sortable: "custom",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.tagTypeParserForiDoctor(
                                row.iDoctorStatus
                              ),
                              effect: "dark",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.tagLabelParserForiDoctor(
                                    row.iDoctorStatus
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "Certified",
                  width: "150",
                  label: "eMSL Certified",
                  sortable: "custom",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.tagTypeParser(row.Active),
                              effect: "dark",
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.tagLabelParser(row.Active)) + " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "LastSend",
                  label: "Last send",
                  "min-width": "140",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "Time",
                  label: "Times",
                  "min-width": "130",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Operation",
                  width: "200",
                  prop: "StatusDesc",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              disabled: !row.Phone || row.iDoctorStatus != 2,
                              type: "text",
                              icon: "el-icon-s-promotion",
                              loading: row.loading,
                              size: "mini",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.sendMessage(row)
                              },
                            },
                          },
                          [_vm._v(" Send SMS ")]
                        ),
                        _c("span", { staticStyle: { padding: "0 5px" } }, [
                          _vm._v("|"),
                        ]),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "text",
                              icon: "iconfont icon-transfer",
                              loading: row.loading,
                              size: "mini",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.openTransferDialog(row)
                              },
                            },
                          },
                          [_vm._v(" Transfer ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "pagination-wrap" },
            [
              _c(
                "div",
                { staticClass: "actions" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "text",
                        icon: "el-icon-s-promotion",
                        size: "medium",
                        disabled: _vm.multipleSelection.length === 0,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.handleMultiSend()
                        },
                      },
                    },
                    [_vm._v(" Mass Send SMS ")]
                  ),
                ],
                1
              ),
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.currentPage,
                  "pager-count": _vm.pagerCount,
                  "page-sizes": [10, 25, 50, 100],
                  "page-size": _vm.pageSize,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "480px",
            title: "Export Report",
            visible: _vm.exportReportDialogVisible,
            scrollbar: false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.exportReportDialogVisible = $event
            },
            closed: _vm.onExportReportClosed,
          },
        },
        [
          _c("p", { staticClass: "export-report-hint" }, [
            _vm._v(
              " 请选择区间日期导出报表，若需导出全量数据，区间日期可留空 "
            ),
          ]),
          _c(
            "div",
            { staticClass: "export-report-picker-wrap" },
            [
              _c("el-date-picker", {
                staticStyle: { width: "100%" },
                attrs: {
                  type: "daterange",
                  "value-format": "yyyy-MM-dd",
                  "start-placeholder": "Begin date",
                  "end-placeholder": "End date",
                  "range-separator": "-",
                  clearable: "",
                },
                model: {
                  value: _vm.exportReportDateRange,
                  callback: function ($$v) {
                    _vm.exportReportDateRange = $$v
                  },
                  expression: "exportReportDateRange",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-actions",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.exportReportLoading },
                  on: { click: _vm.onExportReportSubmit },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.exportReportLoading ? "Exporting..." : "Submit"
                      ) +
                      " "
                  ),
                ]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.exportReportDialogVisible = false
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "300px",
            title: "Mass Reassign",
            visible: _vm.massReassignDialogVisible,
            scrollbar: false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.massReassignDialogVisible = $event
            },
            closed: _vm.onMassReassignClosed,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "massReassignForm",
              staticStyle: { padding: "0 12%" },
              attrs: {
                model: _vm.massReassignForm,
                rules: _vm.massReassignFormRules,
                "label-position": "top",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "callCenterUserId",
                    label: "Select Call Center",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        filterable: "",
                        placeholder: "Please select Call Center",
                      },
                      model: {
                        value: _vm.massReassignForm.callCenterUserId,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.massReassignForm,
                            "callCenterUserId",
                            $$v
                          )
                        },
                        expression: "massReassignForm.callCenterUserId",
                      },
                    },
                    _vm._l(_vm.callCenterOptions, function (item) {
                      return _c("el-option", {
                        key: item.callCenterId,
                        attrs: {
                          label: item.callCenterName,
                          value: item.callCenterId,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-actions",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.massReassignSaving },
                  on: { click: _vm.onMassReassignConfirm },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.massReassignSaving ? "Saving" : "Save") +
                      " "
                  ),
                ]
              ),
              _c("el-button", { on: { click: _vm.onMassReassignClosed } }, [
                _vm._v("Cancel"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "300px",
            title: "Mass Transfer",
            visible: _vm.transferDialogVisible,
            scrollbar: false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.transferDialogVisible = $event
            },
            opened: _vm.onTransferOpened,
            closed: _vm.onTransferClosed,
          },
        },
        [
          _vm.showTransferTip
            ? _c("div", { staticClass: "transfer-tip" }, [
                _vm._v(
                  " 当前vCE已绑定其他vMSL（" +
                    _vm._s(_vm.transferForm.SourceMLName) +
                    "） "
                ),
                _c("br"),
                _vm._v(" 请确认选择正确的绑定vMSL人员 "),
              ])
            : _vm._e(),
          _c(
            "el-form",
            {
              ref: "transferFormRef",
              staticStyle: { padding: "0 12%" },
              attrs: {
                model: _vm.transferForm,
                rules: _vm.transferFormRules,
                "label-position": "top",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "TargetMLID", label: "Select vMSL" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        filterable: "",
                        placeholder: "Please select vMSL",
                      },
                      model: {
                        value: _vm.transferForm.TargetMLID,
                        callback: function ($$v) {
                          _vm.$set(_vm.transferForm, "TargetMLID", $$v)
                        },
                        expression: "transferForm.TargetMLID",
                      },
                    },
                    _vm._l(_vm.allVmslOptions, function (item) {
                      return _c("el-option", {
                        key: item.vMSLId,
                        attrs: { label: item.vMSLName, value: item.vMSLId },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-actions",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.transferSaving },
                  on: { click: _vm.onTransferConfirm },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.transferSaving ? "Saving" : "Save") + " "
                  ),
                ]
              ),
              _c("el-button", { on: { click: _vm.onTransferClosed } }, [
                _vm._v("Cancel"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }